export default class extends Controller {
  static targets = ['onButton', 'neverButton'];

  selectOn() {
    this.onButtonTarget.checked = true;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/event-repeat-ends-on-fields-controller.js